import { Trans } from "react-i18next";
import { Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import i18n from "src/i18n";

import { SESSION_STORAGE_KEYS } from "@constants/index";


interface Props {
  patientFirstName: string;
  countSeconds: number;
  setCallDuration: (arg: number) => void;
  setIsCalling: (arg: boolean) => void;
  setVideoCallThreshold: (val: any) => void;
}

export const openLeaveCallWarningModal = ({
  patientFirstName,
  setCallDuration,
  countSeconds,
  setIsCalling,
  setVideoCallThreshold,
}: Props) => {
  return modals.openConfirmModal({
    withinPortal: true,
    zIndex: 99999,
    title: <Text fw={500}>{i18n.t("end-call")}</Text>,
    centered: true,
    children: (
      <Text lh={1.5} fz={14}>
        <Trans
          i18nKey={"end-call-warning"}
          values={{ patientFirstName }}
          components={{ bold: <Text span fw={500} inherit /> }}
        />
      </Text>
    ),
    labels: { confirm: i18n.t("end-call"), cancel: i18n.t("cancel") },
    groupProps: { gap: "xs", mt: "lg" },
    confirmProps: { color: "red" },
    onCancel: () => {
      // Do something here...
      return;
    },
    onConfirm: () => {
      setCallDuration(countSeconds);
      setIsCalling(false);
      setVideoCallThreshold((prev: any) => ({
        ...prev,
        [SESSION_STORAGE_KEYS.VC_DOCTOR_JOINED]: false,
        [SESSION_STORAGE_KEYS.VC_PATIENT_JOINED]: false,
      }));
    },
    styles: { body: { minHeight: "auto" } },
  });
};
